import { createRoute, Outlet, redirect } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";
import { MsalAuthGuard } from "@/components/MsalAuthGuard";
import { getBackendToken } from "@/lib/tokenCache";
import { msalInstance } from "@/lib/msal/instance";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  id: "_authenticated",
  beforeLoad: () => {
    // Route-level auth gate: runs before any component mounts.
    // Checks localStorage (backend OAuth JWT) and MSAL cache (SSO session).
    const hasToken = getBackendToken() !== null;
    const hasMsal = msalInstance.getAllAccounts().length > 0;
    if (!hasToken && !hasMsal) {
      throw redirect({ to: "/login" });
    }
  },
  component: () => (
    <MsalAuthGuard>
      <Outlet />
    </MsalAuthGuard>
  ),
});
